import { useState, useEffect } from 'react';

import authorizedFetch from 'lib/authorizedFetch';
import config from 'lib/config';

import { SearchItem } from 'types/Apis/SearchResponse';
import { getFirebaseUid, isSignedIn as checkIsSignedIn } from 'lib/Auth';
import getAuthToken from 'lib/getAuthToken';

export default function useFetchSavedSearches(): SearchItem[] {
  const isSignedIn = checkIsSignedIn();
  const [savedSearches, setSavedSearches] = useState<SearchItem[]>([]);
  const firebaseUid = getFirebaseUid();

  useEffect(() => {
    async function fetchSavedSearches(): Promise<void> {
      try {
        if (isSignedIn) {
          await getAuthToken();
        }
        const response = await authorizedFetch(`${config.coreApiUrl}/api/saved_searches`);
        return setSavedSearches(response.saved_searches);
      } catch (error) {
        console.error('Error fetching saved searches:', error);
        return setSavedSearches([]);
      }
    }
    if (isSignedIn && firebaseUid) {
      fetchSavedSearches();
    }
  }, [isSignedIn, firebaseUid]);

  return savedSearches;
}
